/**
 * Levina Drapakoszyk™ — UPSELL „PATYCZKI MATATABI” W KOSZYKU (karta w drawerze + popup z 2 zestawami)
 * ================================================================================================
 * Karta: snippets/levina-kosz-cart-upsell.liquid (renderowana w snippets/cart-drawer.liquid i sections/main-cart-items.liquid).
 * Popup (markup, teksty, style): sections/levina-kosz-cart-upsell-popup.liquid (sekcja statyczna w layout/theme.liquid).
 *
 * CO ROBI
 *   1. Dodaje klasę html.lkc-on (dopiero wtedy karta w koszyku jest widoczna: bez popupu / bez JS karty nie ma).
 *   2. Klik w „Dodaj” na karcie ([data-lkc-open], delegacja z document, więc działa też po każdym odświeżeniu drawera)
 *      otwiera popup (animacja ze środka). NIC nie trafia jeszcze do koszyka.
 *   3. Kafle zestawów = warianty produktu; wybór zmienia cenę na przycisku „Dodaj do koszyka · 89,98 zł”.
 *   4. „Dodaj do koszyka”: POST /cart/add.js: wariant produktu × ILOŚĆ wybranego zestawu (1+1 = 2 szt., 2+2 = 4 szt.; data-qty kafla)
 *      + prośba o sekcje drawera (Section Rendering API). Ceny zestawów robi rabat ilościowy ustawiany w Shopify.
 *      Sukces: popup się zamyka, drawer odświeża się natywną metodą motywu (cart-drawer.renderContents(data, true): bez
 *      ponownego otwierania, drawer zostaje otwarty), bąbelek z liczbą też. Karta znika, bo patyczki są już w koszyku.
 *      Na stronie /cart podmieniane są też .js-contents sekcji main-cart-items i main-cart-footer.
 *      Błąd (422 / sieć / 10 s timeoutu): komunikat w popupie, popup zostaje otwarty, można spróbować ponownie.
 *   5. „Nie, dziękuję”, X, kliknięcie w tło i Esc: zamykają popup bez dodawania. Drawer zostaje otwarty: keyup Esc jest
 *      przechwytywany (drawer motywu zamyka się na keyup Escape), a klik w popup nie dochodzi do tła drawera.
 *
 * ODPORNOŚĆ
 *   - W edytorze motywu (Shopify.designMode) karta jest widoczna (podgląd), ale popup się nie otwiera.
 *   - E-book gratis (levina-kosz-ebook-sync.js) dalej działa: obserwuje fetch do /cart/add, a ten skrypt dodaje WYŁĄCZNIE
 *     wariant patyczków (window.fetch wołany w chwili dodania, więc hook e-booka go widzi).
 *   - Brak drawera / brak sekcji w odpowiedzi: dociągnięcie sekcji GET /cart?sections=…, a gdy i to zawiedzie — przeładowanie strony.
 *   - Własna blokada przewijania (html.lkc-lock) nie rusza blokady drawera (body.overflow-hidden).
 */
(function () {
  'use strict';

  if (window.__levinaCartUpsell) return;
  window.__levinaCartUpsell = true;

  var POPUP_ID = 'levina-cart-upsell';
  var OPEN_SEL = '[data-lkc-open]';
  var ADD_TIMEOUT_MS = 10000;
  var CLOSE_MS = 150;

  var design = false;
  try { design = !!(window.Shopify && window.Shopify.designMode); } catch (e) { /* ignoruj */ }

  if (!document.getElementById(POPUP_ID)) return;          /* sekcja wyłączona / produkt niedostępny: karta zostaje ukryta */
  document.documentElement.classList.add('lkc-on');
  if (design) return;

  var root = null;
  var isOpen = false;
  var busy = false;
  var trigger = null;        /* przycisk „Dodaj” na karcie, który otworzył popup */
  var closeTimer = null;
  var swallowEscUp = false;  /* keyup Esc po zamknięciu popupu nie może zamknąć drawera */

  function $(sel, ctx) { return (ctx || root).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }

  function routeRoot() {
    var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return (typeof r === 'string' && r) ? r : '/';
  }
  function cartUrl() { return (window.routes && window.routes.cart_url) || (routeRoot() + 'cart'); }
  function drawerEl() { return document.querySelector('cart-drawer'); }

  /* ---------- klik w „Dodaj” na karcie (delegacja: karta jest podmieniana przy każdym odświeżeniu drawera) ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var btn = t.closest(OPEN_SEL);
    if (!btn) return;
    e.preventDefault();
    if (isOpen || busy) return;
    open(btn);
  }, true);

  /* ---------- otwieranie / zamykanie ---------- */
  function open(btn) {
    var el = document.getElementById(POPUP_ID);
    if (!el || el.getAttribute('data-ready') !== 'true') return;
    if (el.parentNode !== document.body) document.body.appendChild(el);   /* poza wrapperem sekcji: czysty stacking context nad drawerem */
    root = el;
    bindOnce();
    trigger = btn;
    if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
    resetUI();
    root.classList.remove('is-closing');
    root.hidden = false;
    var sc = $('[data-lkcp-scroll]');
    if (sc) sc.scrollTop = 0;    /* po odkryciu elementu: karta zawsze od góry */
    root.classList.add('is-open');
    document.documentElement.classList.add('lkc-lock');
    isOpen = true;
    if (sc) { try { sc.focus({ preventScroll: true }); } catch (e) { sc.focus(); } }
  }

  function closeUI(restoreFocus) {
    if (!root) return;
    isOpen = false;
    document.documentElement.classList.remove('lkc-lock');
    root.classList.add('is-closing');
    root.classList.remove('is-open');
    if (closeTimer) clearTimeout(closeTimer);
    closeTimer = setTimeout(function () {
      root.hidden = true;
      root.classList.remove('is-closing');
      closeTimer = null;
    }, CLOSE_MS);
    if (restoreFocus) focusBack();
  }

  /* fokus wraca na „Dodaj” na karcie, a gdy karty już nie ma (drawer odświeżony) — do wnętrza drawera */
  function focusBack() {
    var target = (trigger && trigger.isConnected) ? trigger : null;
    if (!target) {
      var d = drawerEl();
      if (d && d.classList.contains('active')) target = d.querySelector('.drawer__inner');
    }
    if (target && target.focus) { try { target.focus({ preventScroll: true }); } catch (e) { /* ignoruj */ } }
  }

  function decline() {
    if (busy || !isOpen) return;
    closeUI(true);
  }

  function accept() {
    if (busy || !isOpen) return;
    var id = selectedId();
    var qty = selectedQty();
    if (!id) return;
    busy = true;
    hideError();
    setBusyUI(true);
    var fromPage = !!(trigger && document.getElementById('main-cart-items') && document.getElementById('main-cart-items').contains(trigger));
    addToCart(id, qty).then(function (data) {
      busy = false;
      setBusyUI(false);
      closeUI(false);
      renderCart(data, fromPage);
    }, function (err) {
      var fail = function () { busy = false; setBusyUI(false); showError(err && err.message); };
      if (!(err && err.network)) { fail(); return; }
      alreadyInCart(id, qty).then(function (found) {
        if (!found) { fail(); return; }
        busy = false;
        setBusyUI(false);
        closeUI(false);
        renderCart({}, fromPage);
      });
    });
  }

  /* ---------- dodanie do koszyka ---------- */
  function sectionIds() {
    var ids = [];
    function add(id) { if (id && ids.indexOf(id) < 0) ids.push(id); }
    var d = drawerEl();
    try {
      if (d && typeof d.getSectionsToRender === 'function') d.getSectionsToRender().forEach(function (s) { add(s && s.id); });
    } catch (e) { /* ignoruj */ }
    if (!ids.length && document.getElementById('cart-icon-bubble')) add('cart-icon-bubble');
    var items = document.getElementById('main-cart-items');
    var footer = document.getElementById('main-cart-footer');
    if (items) add(items.getAttribute('data-id'));
    if (footer) add(footer.getAttribute('data-id'));
    return ids.slice(0, 5);   /* limit Section Rendering API */
  }

  function addToCart(id, qty) {
    if (typeof window.fetch !== 'function') return Promise.reject(new Error(''));
    var ids = sectionIds();
    var payload = { items: [{ id: id, quantity: qty > 0 ? qty : 1 }] };   /* zestawy 1+1 / 2+2 = ilość jednego wariantu; rabat ilościowy robi Shopify */
    if (ids.length) {
      payload.sections = ids.join(',');
      payload.sections_url = window.location.pathname;
    }
    var opts = {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    };
    var tm = null;
    try {
      if (window.AbortController) {
        var ctrl = new AbortController();
        opts.signal = ctrl.signal;
        tm = setTimeout(function () { try { ctrl.abort(); } catch (e) { /* ignoruj */ } }, ADD_TIMEOUT_MS);
      }
    } catch (e) { /* bez timeoutu */ }
    return window.fetch(routeRoot() + 'cart/add.js', opts).then(function (res) {
      return res.text().then(function (txt) {
        if (tm) clearTimeout(tm);
        var data = null;
        try { data = txt ? JSON.parse(txt) : null; } catch (e) { data = null; }
        if (!res.ok) {
          var msg = data && (data.description || data.message);
          throw new Error(typeof msg === 'string' ? msg : '');
        }
        if (data && !data.__ids) { try { Object.defineProperty(data, '__ids', { value: ids }); } catch (e) { /* ignoruj */ } }
        return data || {};
      });
    }, function () {
      if (tm) clearTimeout(tm);
      var ne = new Error(''); ne.network = true;
      throw ne;
    });
  }

  /* po błędzie sieci / przerwaniu (timeout) zestaw mógł już trafić do koszyka: sprawdź /cart.js, żeby ponowienie nie dodało go drugi raz */
  function alreadyInCart(id, qty) {
    if (typeof window.fetch !== 'function') return Promise.resolve(false);
    return window.fetch(routeRoot() + 'cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } }).then(function (r) {
      return r.ok ? r.json() : null;
    }).then(function (c) {
      var items = (c && c.items) || [];
      for (var i = 0; i < items.length; i++) if (String(items[i].variant_id) === String(id) && items[i].quantity >= (qty > 0 ? qty : 1)) return true;
      return false;
    }).catch(function () { return false; });
  }

  /* ---------- odświeżenie drawera / strony koszyka z odpowiedzi add.js ---------- */
  function renderCart(data, fromPage) {
    if (data && data.sections) { applySections(data, fromPage); return; }
    var ids = (data && data.__ids) || sectionIds();
    if (!ids.length) { reloadPage(); return; }
    window.fetch(cartUrl() + '?sections=' + ids.join(','), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('sections'); return r.json(); })
      .then(function (json) { (data || (data = {})).sections = json; applySections(data, fromPage); })
      .catch(reloadPage);
  }

  function reloadPage() { try { window.location.reload(); } catch (e) { /* ignoruj */ } }

  function parseSection(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.querySelector(selector);
  }

  function applySections(data, fromPage) {
    var sections = data.sections || {};
    var ok = false;
    try {
      var d = drawerEl();
      if (d && sections['cart-drawer'] && typeof d.renderContents === 'function') {
        d.classList.remove('is-empty');
        d.renderContents(data, true);   /* natywna ścieżka motywu; true = bez ponownego otwierania (otwarty drawer zostaje otwarty) */
        ok = true;
      } else if (sections['cart-icon-bubble']) {
        var bubble = document.getElementById('cart-icon-bubble');
        var src = parseSection(sections['cart-icon-bubble'], '.shopify-section');
        if (bubble && src) bubble.innerHTML = src.innerHTML;
      }
    } catch (e) { ok = false; }
    try {
      ['main-cart-items', 'main-cart-footer'].forEach(function (elId) {
        var el = document.getElementById(elId);
        var html = el && sections[el.getAttribute('data-id')];
        if (!html) return;
        var srcC = parseSection(html, '.js-contents');
        var dst = el.querySelector('.js-contents');
        if (srcC && dst) { dst.innerHTML = srcC.innerHTML; ok = true; }
      });
    } catch (e) { /* ignoruj */ }
    if (!ok) { reloadPage(); return; }
    /* fokus: stary przycisk karty zniknął razem z odświeżonym drawerem, a przycisk popupu za chwilę się schowa */
    if (!fromPage) {
      var dd = drawerEl();
      var inner = dd && dd.classList.contains('active') ? dd.querySelector('.drawer__inner') : null;
      var ae = document.activeElement;
      if (inner && (!ae || ae === document.body || !ae.isConnected || (root && root.contains(ae)))) {
        try {
          if (typeof trapFocus === 'function') trapFocus(dd, inner);   /* motyw: ponowne uzbrojenie pułapki Tab po odświeżeniu */
          else inner.focus({ preventScroll: true });
        } catch (e) { try { inner.focus({ preventScroll: true }); } catch (e2) { /* ignoruj */ } }
      }
    }
  }

  /* ---------- UI ---------- */
  function radios() { return $$('input[name="lkcp-bundle"]'); }
  function selectedRadio() {
    var r = radios();
    for (var i = 0; i < r.length; i++) if (r[i].checked) return r[i];
    return r[0] || null;
  }
  function selectedId() {
    var r = selectedRadio();
    return r ? (Number(r.value) || 0) : 0;
  }
  function selectedQty() {
    var r = selectedRadio();
    var q = r ? parseInt(r.getAttribute('data-qty'), 10) : 1;
    return q > 0 ? q : 1;
  }

  function syncTiles() {
    var cur = selectedRadio();
    radios().forEach(function (r) {
      var tile = r.closest('.lkcp__tile');
      if (tile) tile.classList.toggle('is-selected', r === cur);
    });
    var sum = $('[data-lkcp-sum]');
    if (sum && cur) sum.textContent = cur.getAttribute('data-sum') || '';
  }

  function setBusyUI(on) {
    $$('[data-lkcp-add], [data-lkcp-no], .lkcp__x').forEach(function (b) { b.disabled = !!on; });
    radios().forEach(function (r) { r.disabled = !!on; });
    var lab = $('[data-lkcp-add-label]');
    if (lab) lab.textContent = on ? (root.getAttribute('data-adding-label') || 'Dodaję…') : (root.getAttribute('data-add-label') || 'Dodaj do koszyka');
    var sw = $('[data-lkcp-sum-wrap]');
    if (sw) sw.hidden = !!on;
  }

  function showError(msg) {
    var el = $('[data-lkcp-error]');
    if (!el) return;
    el.textContent = msg || root.getAttribute('data-error-label') || 'Nie udało się dodać do koszyka. Spróbuj ponownie.';
    el.hidden = false;
    try { el.scrollIntoView({ block: 'nearest' }); } catch (e) { /* ignoruj */ }
  }
  function hideError() {
    var el = $('[data-lkcp-error]');
    if (el) { el.hidden = true; el.textContent = ''; }
  }

  function resetUI() {
    hideError();
    setBusyUI(false);
    var def = $('input[name="lkcp-bundle"][data-default]');
    if (def) def.checked = true;
    syncTiles();
    var track = $('[data-lkcp-track]');
    if (track) track.scrollLeft = 0;
    var sc = $('[data-lkcp-scroll]');
    if (sc) sc.scrollTop = 0;
    markGallery(0);
  }

  /* galeria (jak w popupie poduszki) */
  function slideCount() { var tr = $('[data-lkcp-track]'); return tr ? tr.children.length : 0; }
  function markGallery(i) {
    var n = slideCount();
    $$('[data-lkcp-thumb]').forEach(function (th, k) { th.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    var prev = $('[data-lkcp-prev]'), next = $('[data-lkcp-next]');
    if (prev) prev.disabled = i <= 0;
    if (next) next.disabled = i >= n - 1;
  }
  function currentIndex() {
    var tr = $('[data-lkcp-track]');
    return tr && tr.clientWidth ? Math.round(tr.scrollLeft / tr.clientWidth) : 0;
  }
  function goTo(i) {
    var tr = $('[data-lkcp-track]');
    if (!tr) return;
    i = Math.max(0, Math.min(slideCount() - 1, i));
    var behavior = 'smooth';
    try { if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) behavior = 'auto'; } catch (e) { /* ignoruj */ }
    try { tr.scrollTo({ left: i * tr.clientWidth, behavior: behavior }); } catch (e) { tr.scrollLeft = i * tr.clientWidth; }
    markGallery(i);
  }

  function focusables() {
    return $$('button:not([disabled]), input:not([disabled]), [href]').filter(function (el) {
      if (el.type === 'radio' && !el.checked) return false;   /* grupa radio = jeden przystanek Tab */
      return el.offsetParent !== null || el === document.activeElement;
    });
  }

  var bound = false;
  function bindOnce() {
    if (bound) return;
    bound = true;

    root.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('[data-lkcp-add]')) { accept(); return; }
      if (t.closest('[data-lkcp-no]')) { decline(); return; }
      var th = t.closest('[data-lkcp-thumb]');
      if (th) { goTo(parseInt(th.getAttribute('data-lkcp-thumb'), 10) || 0); return; }
      if (t.closest('[data-lkcp-prev]')) { goTo(currentIndex() - 1); return; }
      if (t.closest('[data-lkcp-next]')) { goTo(currentIndex() + 1); }
    });

    root.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'lkcp-bundle') { hideError(); syncTiles(); }
    });

    var tr = $('[data-lkcp-track]');
    if (tr) {
      var wait = null;
      tr.addEventListener('scroll', function () {
        if (wait) clearTimeout(wait);
        wait = setTimeout(function () { markGallery(currentIndex()); }, 80);
      }, { passive: true });
    }
  }

  /* Esc i Tab (capture: popup ma pierwszeństwo przed drawerem) */
  document.addEventListener('keydown', function (e) {
    var isEsc = e.key === 'Escape' || e.key === 'Esc' || e.code === 'Escape';
    if (!isOpen) { if (isEsc && !e.repeat) swallowEscUp = false; return; }
    if (isEsc) {
      e.preventDefault();
      e.stopPropagation();
      swallowEscUp = true;
      decline();
      return;
    }
    if (e.key !== 'Tab') return;
    var f = focusables();
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    var onDialog = document.activeElement === $('[data-lkcp-scroll]');
    if (e.shiftKey && (onDialog || document.activeElement === first || !root.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (document.activeElement === last || !root.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
  }, true);

  /* drawer motywu zamyka się na keyup Escape: ten keyup należy jeszcze do popupu */
  window.addEventListener('keyup', function (e) {
    if (!swallowEscUp) return;
    if (e.key === 'Escape' || e.key === 'Esc' || e.code === 'Escape') {
      swallowEscUp = false;
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    }
  }, true);

  /* bfcache: po powrocie do strony popup nie może zostać otwarty */
  window.addEventListener('pageshow', function (e) {
    if (e && e.persisted && root) {
      isOpen = false; busy = false; trigger = null; swallowEscUp = false;
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      root.hidden = true;
      root.classList.remove('is-open', 'is-closing');
      document.documentElement.classList.remove('lkc-lock');
    }
  });

  /* diagnostyka z konsoli: LevinaCartUpsell.isOpen() */
  window.LevinaCartUpsell = { isOpen: function () { return isOpen; }, isBusy: function () { return busy; } };
})();
